export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 10;
export const MIN_ISSUES_FOR_VISIBLE_SCAN = 0;

export const MobileScansListSortFields = {
	ScanCreatedAt: 'scan_created_at',
	ScanName: 'scan_name',
	TotalIssues: 'total_issues',
	CriticalIssues: 'critical_issues',
	SeriousIssues: 'serious_issues',
	ElementsWithIssues: 'elements_with_issues'
} as const;
export type MobileScansListSortFields =
	(typeof MobileScansListSortFields)[keyof typeof MobileScansListSortFields];

export const MobileScansListSortOrder = {
	Ascending: 'Ascending',
	Descending: 'Descending'
} as const;
export type MobileScansListSortOrder =
	(typeof MobileScansListSortOrder)[keyof typeof MobileScansListSortOrder];

export const MOBILE_SCANS_LIST_ENTITY_NAME = 'mobile_scans_list';
